import { cn } from '@/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md !z-[5] bg-neutral-800/90',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
